// extracted by mini-css-extract-plugin
export default {"inputBox":"AIPanelInputBox__inputBox___VsElf","disabled":"AIPanelInputBox__disabled___nXlaa"};